export default __webpack_public_path__ + "static/media/Compendium.1ce00665.jpg";